/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { EgridMeta } from './egridMeta';
import { HistInfoMeta } from './histInfoMeta';
import { GrundstueckId } from './grundstueckId';
import { CodeEntryMeta } from './codeEntryMeta';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GebaeudeArt } from './gebaeudeArt';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckListEntryMeta { 
    flurnamen?: Array<string>;
    mFlurnamen?: FieldMetaData;
    isMeldungsrelevant?: boolean;
    mIsMeldungsrelevant?: FieldMetaData;
    sdrArt?: GrundstueckListEntryMeta.SdrArtEnum;
    mSdrArt?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
    grundstueckId?: GrundstueckId;
    mGrundstueckId?: FieldMetaData;
    grundstueckArt?: GrundstueckListEntryMeta.GrundstueckArtEnum;
    mGrundstueckArt?: FieldMetaData;
    codeUnterart?: CodeEntryMeta;
    mCodeUnterart?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    egrid?: EgridMeta;
    mEgrid?: FieldMetaData;
    sonderrechtText?: string;
    mSonderrechtText?: FieldMetaData;
    ligArt?: GrundstueckListEntryMeta.LigArtEnum;
    mLigArt?: FieldMetaData;
    dokulinkVerfuegbar?: GrundstueckListEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    gebaeudeArten?: Array<GebaeudeArt>;
    mGebaeudeArten?: FieldMetaData;
    isKopie?: boolean;
    mIsKopie?: FieldMetaData;
    grundstueckPDFpossible?: boolean;
    mGrundstueckPDFpossible?: FieldMetaData;
    permissions?: GrundstueckPermissions;
    mPermissions?: FieldMetaData;
    grundstueckRTFpossible?: boolean;
    mGrundstueckRTFpossible?: FieldMetaData;
    flaechenMaessigNichtAusgeschieden?: boolean;
    mFlaechenMaessigNichtAusgeschieden?: FieldMetaData;
    grundstueckNummer?: GrundstueckNummerListEntry;
    mGrundstueckNummer?: FieldMetaData;
    flaecheQuadratMeter?: number;
    mFlaecheQuadratMeter?: FieldMetaData;
}
export namespace GrundstueckListEntryMeta {
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'WEITERE';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        WEITERE: 'WEITERE' as SdrArtEnum
    };
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
    export type LigArtEnum = 'STRASSENPARZELLE' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STRASSENPARZELLE: 'STRASSENPARZELLE' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        NICHTVORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


